import React from 'react';
import { Main } from './components';

export const ReusedReceive: React.FC = () => {
    return <Main />;
};

